export const routes = {
    home: '/',
    checkout: '/checkout',
    news: '/news',
    newsDetails: '/news/:id',
    category: '/category/:id',
    product: '/product/:id',
    products: '/products/:id',
    newArrivals: '/products/newArrivals',
    sales: '/products/sales',
    auth: {
        login: '/auth/login',
        registration: '/auth/registration',
        resetPassword: '/reset-password'
    },
    aboutUs: '/about',
    allCategories: '/categories',
    delivery: '/delivery',
    faq: '/faq',
    contacts: '/contacts',
    profile: {
        index: '/profile',
        cart: '/cart',
        deliveryAddress: '/address',
        favorites: '/favorites',
        myOrders: '/orders',
        subscription: '/subscription',
        viewedProducts: '/viewed'
    },
    terms: '/terms-of-use',
    privacy: '/privacy-policy',
    returnPolicy: '/return-policy'
}
